module.exports = __webpack_public_path__ + "static/img/iphone_room3.0da8f4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_room3.png
// module id = S0n0
// module chunks = 0